module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAbFBMVEVHcEz///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8EZPb1AAAAI3RSTlMACx+yU40MjvvC/u3XAWUb/C3qKimG5aGF5nl6OEq4S7ne3dfxgUkAAAC6SURBVDjLfdJHEoMwEETRljHI5OCcQ9//jjYWKtIMbCTV+wuqZnDL0ivk7/5pCiAjaUVfb8iqREqlaJ2scaFcOH/lQCgWzuOovUvF0KVi7PNi6tNi7uNC8mEhe19o7otAdV/o3heaA8Hfz6q7/9Om3/vSfpAHLu9HHNnF/YgNYJf2w7R3q++HcS+r7Yfxb1eEqk+LuY8LyYfFU3RfnIC37F2RrNAo3hU7FBUfRp7ePuHxd5R1rs1/tQW+FlwnewVwrhUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/assets/close.png
// module id = 144
// module chunks = 15